import { getArticles, getAuthors, getCategories } from '@/graphql/queries/media/article';
import lang from '@/lang/middleware/media';

export default async ({ $apolloQuery, app, redirect, route, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const { author, category, page, tag } = route.params;
  const breadcrumbs = [['i18n/home', '/']];
  let description, jumbotronTitle, title;
  let showJumbo = true;

  const fail = (path, key, opts = {}) => {
    redirect(302, app.localePath(path), { flashClass: 'error', flashMessage: store.$i18n.t(`errors.${key}`, opts) });
  };

  await $apolloQuery(getAuthors).then(authors => store.commit('blog/setAuthors', authors));
  await $apolloQuery(getCategories).then(categories => store.commit('blog/setCategories', categories));

  if (author) {
    const authorInfo = store.getters['blog/getAuthors'].find(a => a.author_slug === author);
    if (authorInfo) {
      store.commit('blog/setAuthor', authorInfo);
    } else {
      return fail('/blog/authors/', 'authorNotFound');
    }
    title = authorInfo.fullname;
    breadcrumbs.push(['i18n/blog', '/blog/']);
    breadcrumbs.push(title);
    description = authorInfo.bio;
    showJumbo = false;
  } else if (category) {
    if (!store.getters['blog/getCategories'].find(c => c.slug === category)) {
      return fail('/blog/', 'categoryNotFound', [category]);
    }
    breadcrumbs.push(['i18n/blog', '/blog/']);
    breadcrumbs.push(`i18n/articleCategories.${category}`);
    description = store.$i18n.t(`blog.categories.${category}.description`);
    jumbotronTitle = title = store.$i18n.t(`blog.categories.${category}.title`);
  } else {
    if (tag) {
      breadcrumbs.push(['i18n/blog', '/blog/']);
      breadcrumbs.push(tag);
    } else {
      breadcrumbs.push('i18n/blog');
    }
    description = store.$i18n.t('blog.index.description');
    jumbotronTitle = store.$i18n.t('blog.index.jumbotron.title');
    title = store.$i18n.t('blog.index.title');
  }
  if (showJumbo) {
    store.commit('jumbotron/SET_JUMBOTRON', { extra: 'site-blog-newsletter-signup', title: jumbotronTitle, type: 'generic' });
  }
  await $apolloQuery(getArticles, { author, category, page, tag }).then(result => {
    store.commit('blog/setList', result.articles);
    store.commit('utils/setPagination', result.meta.pagination);
  });
  store.commit('pageContent/setHead', { description, title });
  store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', breadcrumbs);
};
